"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPeople = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconPeople = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "44",
    height: "40",
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.7486 19.9979H23.9124C21.4511 19.9979 19.1845 20.8454 17.3323 22.2666C16.794 22.1579 16.245 22.0829 15.6784 22.0829H8.87865C3.97006 22.0829 0 26.3278 0 31.5477V36.9849C0 37.54 0.424982 37.9861 0.945615 37.9861H12.6575V39.0024C12.6575 39.5538 13.0825 40 13.6031 40L41.9474 39.94C42.324 39.8027 43.0769 39.368 43.0769 38.7273V31.9264C43.0769 24.8619 39.4711 19.9979 32.7486 19.9979ZM25.8001 21.9967H23.9125C18.71 21.9967 14.5489 26.4216 14.5489 31.964V38.0049H18.7775V32.9987C18.774 32.4477 19.1883 31.9864 19.7089 31.9864C20.2402 31.979 20.6758 32.4363 20.6687 32.9987V38.0049H35.504C35.596 38.0049 35.688 38.0163 35.7766 38.0461V32.9987C35.7729 32.4477 36.1258 31.9864 36.6465 31.9864C37.0071 31.9864 37.3898 32.3692 37.3898 32.9987C37.3898 32.9987 37.2283 37.035 37.3898 38.0049L41.3335 37.9861V31.9264C41.3335 27.3104 39.2628 21.9967 32.7486 21.9967H30.868H25.8001ZM15.4518 24.0892H8.87871C4.99369 24.0892 1.89128 27.3965 1.89128 31.5513V35.9913H4.71037V32.3538C4.69966 31.7987 5.1176 31.3375 5.64175 31.3375C6.17298 31.3301 6.60505 31.7913 6.59797 32.3538V35.9913H12.6575V31.964C12.6575 28.9453 13.7164 26.1928 15.4518 24.0892Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.332 0C23.6714 0 19.8749 4.04234 19.8749 8.99972C19.8749 13.9534 23.6714 17.9994 28.332 17.9994C32.9963 17.9994 36.7892 13.9534 36.7892 8.99972C36.7892 4.04234 32.9963 0 28.332 0ZM28.332 1.99866C31.9692 1.99866 34.9015 5.11855 34.8981 8.99972C34.8981 12.8809 31.9692 15.997 28.332 15.997C24.6984 15.997 21.7625 12.8809 21.7625 8.99972C21.7625 5.11855 24.6984 1.99866 28.332 1.99866ZM12.2783 6.65231C8.57033 6.65231 5.55286 9.88095 5.55286 13.8259C5.55286 17.7745 8.57024 21.0032 12.2783 21.0032C15.9863 21.0032 19.0037 17.7745 19.0037 13.8259C19.0037 9.88095 15.9863 6.65231 12.2783 6.65231ZM12.2783 8.65095C14.9557 8.65095 17.116 10.9534 17.116 13.8258C17.116 16.7019 14.9557 19.0043 12.2783 19.0043C9.60089 19.0043 7.44058 16.7019 7.44058 13.8258C7.44058 10.9534 9.60089 8.65095 12.2783 8.65095Z",
      fill: color
    }, void 0)]
  }), void 0);
});